// extracted by mini-css-extract-plugin
export default {"titleUnderline":"styles__titleUnderline___MuMJL","titleUnderlineSpan":"styles__titleUnderlineSpan___EXumr"};